import { JackpotConnector } from 'services/sockets/jackpot-connector';

export const connectingJackpotWS = JackpotConnector();
